import { areExperimentalFeaturesEnabled } from '#services';
export const experimentalFeatureRoute = (v) => areExperimentalFeaturesEnabled() ? v : null;
